import React from "react";
import "./StaticServicesInfo.css";
import Icons from "../../../../Config/Images";
const StaticServicesInfo = () => {
  return (
    <>
      <div className="servicesInfoDiv">
        <div>
          <img
            style={{ width: "46px", height: "46px" }}
            src={Icons.paymentIcon}
            alt=""
          />
          <p
            style={{
              fontSize: "14px",
              color: "#181818",
              fontWeight: 400,
              fontFamily: "'Poppins', sans-serif",
              marginTop: "6px",
            }}
          >
            Payment
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "#727272",
              fontWeight: 400,
              fontFamily: "'Poppins', sans-serif",
              marginTop: "4px",
            }}
          >
            Secure, flexible options
          </p>
        </div>
        <div
          className="vl"
          style={{ height: "120px", width: "2px", backgroundColor: "#727272" }}
        ></div>
        <div>
          <img
            style={{ width: "46px", height: "46px" }}
            src={Icons.shippingAndDeliveryIcon}
            alt=""
          />
          <p
            style={{
              fontSize: "14px",
              color: "#181818",
              fontWeight: 400,
              fontFamily: "'Poppins', sans-serif",
              marginTop: "6px",
            }}
          >
            Shipping & Delivery
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "#727272",
              fontWeight: 400,
              fontFamily: "'Poppins', sans-serif",
              marginTop: "4px",
            }}
          >
            Fast and reliable
          </p>
        </div>
        <div
          className="vl"
          style={{ height: "120px", width: "2px", backgroundColor: "#727272" }}
        ></div>
        <div>
          <img
            style={{ width: "46px", height: "46px" }}
            src={Icons.shieldTickIcon}
            alt=""
          />
          <p
            style={{
              fontSize: "14px",
              color: "#181818",
              fontWeight: 400,
              fontFamily: "'Poppins', sans-serif",
              marginTop: "6px",
            }}
          >
            High Quality
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "#727272",
              fontWeight: 400,
              fontFamily: "'Poppins', sans-serif",
              marginTop: "4px",
            }}
          >
            Premium materials
          </p>
        </div>
        <div
          className="vl"
          style={{ height: "120px", width: "2px", backgroundColor: "#727272" }}
        ></div>
        <div>
          <img
            style={{ width: "46px", height: "46px" }}
            src={Icons.paymentIcon}
            alt=""
          />
          <p
            style={{
              fontSize: "14px",
              color: "#181818",
              fontWeight: 400,
              fontFamily: "'Poppins', sans-serif",
              marginTop: "6px",
            }}
          >
            Sustainability
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "#727272",
              fontWeight: 400,
              fontFamily: "'Poppins', sans-serif",
              marginTop: "4px",
            }}
          >
            Eco-friendly practices
          </p>
        </div>

        <div
          className="vl"
          style={{ height: "120px", width: "2px", backgroundColor: "#727272" }}
        ></div>

        <div>
          <img
            style={{ width: "46px", height: "46px" }}
            src={Icons.shieldTickIcon}
            alt=""
          />
          <p
            style={{
              fontSize: "14px",
              color: "#181818",
              fontWeight: 400,
              fontFamily: "'Poppins', sans-serif",
              marginTop: "6px",
            }}
          >
            Exclusive Designs
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "#727272",
              fontWeight: 400,
              fontFamily: "'Poppins', sans-serif",
              marginTop: "4px",
            }}
          >
             Unique & elegant pieces
          </p>
        </div>

        <div
          className="vl"
          style={{ height: "120px", width: "2px", backgroundColor: "#727272" }}
        ></div>
        <div>
          <img
            style={{ width: "46px", height: "46px" }}
            src={Icons.paymentIcon}
            alt=""
          />
          <p
            style={{
              fontSize: "14px",
              color: "#181818",
              fontWeight: 400,
              fontFamily: "'Poppins', sans-serif",
              marginTop: "6px",
            }}
          >
            24/7 Support
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "#727272",
              fontWeight: 400,
              fontFamily: "'Poppins', sans-serif",
              marginTop: "4px",
            }}
          >
            We’re here to help
          </p>
        </div>
      </div>
    </>
  );
};

export default StaticServicesInfo;
